<template>
  <div>
    <div v-if="deviceList.length > 0">
      <el-row style="margin: 10px 0 15px 0; font-size: 0.9rem">
        <ul style="clear: both">
          <li>
            <el-select
              v-model="currentSelectDoorId"
              @change="change"
              placeholder="请选择"
              size="small"
              style="width: 95%"
            >
              <el-option
                style="float: none; text-align: center"
                v-for="item in deviceList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </li>
        </ul>
      </el-row>
      <el-row style="margin: 0 0 0 25px; font-size: 0.9rem">
        <ul>
          <li>
            <img
              src="../../../assets/images/comprehensive/门禁记录.png"
              style="margin-bottom: 2px"
            />
            <span class="ml-1 mr-1" style="font-weight: bold">门禁记录</span>
          </li>
          <li style="color: rgba(41, 159, 251, 1); font-weight: bold">
            <span v-if="doorLogs.total > 0">
              {{ doorLogs.total ? "共" + doorLogs.total + "条" : "暂无记录" }}
            </span>
            <span v-else-if="doorLogs.total <= 0"> 暂无记录 </span>
          </li>
        </ul>
      </el-row>
      <div style="overflow-y: auto;height: calc(100vh - 200px);">
        <!--    门禁系统-->
        <el-row
          :key="item.id"
          style="margin-left: 35px; margin-top: 10px; font-size: 0.9rem"
          v-for="item in doorLogs.records"
        >
          <div
            class="p-3"
            style="
              width: 92%;
              border: 1px solid rgba(41, 155, 255, 0.2);
              border-radius: 5px;
            "
          >
            <el-row>门点名称：{{ item.area }}</el-row>
            <el-row style="margin-top: 5px"
              >人员名称：{{ item.name }}</el-row
            >
            <el-row style="margin-top: 5px"
              >设备：{{ item.door }}</el-row
            >
            <el-row style="margin-top: 5px"
              >名称动作事件结果：{{ item.eventResultName }}</el-row
            >
            <el-row style="margin-top: 5px"
              >动作事件触发动作：{{ item.eventActionWayName }}</el-row
            >
            <el-row style="margin-top: 5px"
              >验证方式：{{ item.verifyTypeName }}</el-row
            >
            <el-row style="margin-top: 5px"
              >进出标识：{{ item.log }}</el-row
            >
            <el-row style="margin-top: 5px"
              >凭据类型：{{ item.typeName }}</el-row
            >
            <el-row style="margin-top: 5px"
              >事件发生时间：{{ item.time }}</el-row
            >
          </div>
        </el-row>
        <el-pagination
          :current-page="doorLogs.current"
          :hide-on-single-page="true"
          :page-size="doorLogs.size"
          :pager-count="5"
          :small="true"
          :total="doorLogs.total"
          @current-change="pageChange"
          class="mb-4 mt-3 text-center"
          layout="prev, pager, next"
          style="padding-left: 35px; width: 92%"
          v-if="doorLogs.total > 0"
        >
        </el-pagination>
      </div>
    </div>
    <no-data style="margin-top: 20%" v-else></no-data>
  </div>
</template>

<script>
import NoData from "@/components/NoData";
import { getHikvisionAccessControl } from "@/network/entranceguard";

export default {
  name: "DasDoorOV",
  components: { NoData },
  props: ["deviceList"],
  data() {
    return {
      doorLogs: [],
      // 当前选中门的id
      currentSelectDoorId: "",
      page: {
        data: {
          max: 3,
          index: 1,
        },
      },
    };
  },
  watch: {
    currentSelectDoorId() {
      this.getData(
        this.page.data.index,
        this.page.data.max,
        this.currentSelectDoorId
      );
    },
    deviceList() {
      this.currentSelectDoorId =
        this.deviceList.length > 0 ? this.deviceList[0].id : "";
      this.getData(
        this.page.data.index,
        this.page.data.max,
        this.currentSelectDoorId
      );
    },
  },
  mounted() {
    this.getData(
      this.page.data.index,
      this.page.data.max,
      this.currentSelectDoorId
    );
  },
  methods: {
    getData(index, max, currentSelectDoorId) {
      getHikvisionAccessControl(index, max, currentSelectDoorId).then((res) => {
        if (res.code === 0) {
          this.doorLogs = res.data;
        }
      });
    },
    // 翻页
    pageChange(page) {
      this.getData(page, this.page.data.max, this.currentSelectDoorId);
    },
    change() {
      this.getData(
        this.page.data.index,
        this.page.data.max,
        this.currentSelectDoorId
      );
    },
  },
};
</script>

<style scoped>
ul li,
ul {
  padding: 0;
  float: left;
  list-style: none;
}
</style>
